<script setup lang="ts">
/**
 * Thin wrapper around CommunicationAckForm for backward compatibility.
 * Existing consumers (AnnouncementDetail.vue) use this component unchanged.
 */
import CommunicationAckForm from './CommunicationAckForm.vue'

defineProps<{
  communicationId: string
  requiresSignature: boolean
}>()

const emit = defineEmits<{
  acknowledged: []
}>()
</script>

<template>
  <CommunicationAckForm
    :communication-id="communicationId"
    :requires-signature="requiresSignature"
    @acknowledged="emit('acknowledged')"
  />
</template>
